import { Box, Typography } from '@mui/material';
import React from 'react';
import { Controller, UseControllerProps, useFormContext } from 'react-hook-form';

import { useCommonStyles } from '~/styles/commonStyles';
import { SurveyHelper, HappyScaleType } from '~helpers/SurveyHelper';

interface IHappyScaleBoxProps {
  name: string;
  value: number;
  scaleType: HappyScaleType;
  hookFormProps?: Omit<UseControllerProps<any>, 'name' | 'render'>;
}

export const HappyScaleBoxWithController: React.FC<IHappyScaleBoxProps> = (props) => {
  const { name, value, scaleType, hookFormProps } = props;
  const { classes: commonClasses } = useCommonStyles();

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      render={({ field }) => {
        const isSelected = field.value === value;
        const backgroundColor = SurveyHelper.getHappyScaleBackgroundColor(value, isSelected, scaleType);

        return (
          <Box
            onClick={() => field.onChange(value)}
            className={commonClasses.happyScaleItem}
            sx={{
              backgroundColor,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <Typography variant="body1">{value}</Typography>
          </Box>
        );
      }}
      {...hookFormProps}
      control={hookFormProps?.control || control}
    />
  );
};
